/**
 * Route + embed wrapper for the Document Form designer (obj_type "E").
 *
 * Mirrors the other designers: full-page at
 * `/designers/document-form/:project/:objName`, or embedded in the workbench
 * "Design" tab via `embedProject` / `embedObjName`. The editor itself lives in
 * `documentform/DocumentFormDesignerPage` so the workbench can mount it
 * without pulling in routing.
 */

import { useParams } from 'react-router-dom'
import type { EmbeddedDesignerProps } from './embeddedDesigner'
import Editor from './documentform/DocumentFormDesignerPage'

/** Which tab to land on. The route always opens on Settings; a host that
 *  already made those decisions (the Visual designer's "Design document",
 *  which has just written the source and the identity) says so instead. */
export interface DocumentFormRouteProps extends EmbeddedDesignerProps {
  initialTab?: 'settings' | 'sections' | 'fields' | 'body' | 'sign-off'
}

export default function DocumentFormDesignerRoute(props: DocumentFormRouteProps) {
  const params = useParams<{ project?: string; objName?: string }>()
  const project = props.embedded ? (props.embedProject || '') : (params.project || '')
  const objName = props.embedded ? (props.embedObjName || '') : (params.objName || '')

  if (!project || !objName) {
    return (
      <div style={{ padding: 24, fontSize: 14, color: 'var(--color-text-secondary)' }}>
        Select a document form to design.
      </div>
    )
  }
  return <Editor project={project} objName={objName} {...props} />
}
